/**
 * Copy-to-clipboard for share buttons (single blog post).
 * Looks for buttons with `data-prlab-copy="<url>"` and copies the value
 * to the clipboard, briefly flashing the button to confirm.
 */
export function initShareCopy() {
  document.querySelectorAll('[data-prlab-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = btn.getAttribute('data-prlab-copy') || window.location.href;
      try {
        await navigator.clipboard.writeText(url);
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 1400);
      } catch (e) {
        // Fallback: select-and-prompt.
        window.prompt('Copy link', url);
      }
    });
  });
}
